<template>
    <div class="customer-manage">
        <div class="flex items-center justify-between">
            <vs-button color="primary" icon-pack="feather" icon="icon-plus" @click="popupAddCustomer = true">
                Thêm mới khách hàng
            </vs-button>
            <h3 class="text-primary text-center flex-1 text-center"
                style="transform: translateX(-50%);left: 50%;position: absolute;">DANH SÁCH KHÁCH HÀNG ĐẶT LỊCH</h3>
        </div>
        <div class="vx-card px-4 py-2 mt-2">
            <div class="">
                <vs-table :data="beautyBookingData" noDataText="Không có dữ liệu"
                    style="height: calc(var(--vh, 1vh) * 100 - 200px); min-height: 300px">
                    <template slot="thead">
                        <vs-th>
                            STT
                        </vs-th>
                        <vs-th style="min-width: 200px">
                            <div class="w-full">
                                <label>Khách hàng</label>
                                <vs-input class="w-full" v-model="customerName" @keyup.enter="filter"></vs-input>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px">
                            <div class="w-full">
                                <label>SĐT</label>
                                <vs-input class="w-full" v-model="phoneNumber" @keyup.enter="filter"></vs-input>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px">
                            <div class="w-full">
                                <label>Nguồn khai thác</label>
                                <v-select v-model="sourcePlatformValue" :options="sourcePlatformOptions"
                                    :clearable="false" @input="filter" :reduce="option => option.value">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px">
                            <div class="w-full">
                                <label>Nguồn khách</label>
                                <v-select v-model="sourceValue" :options="sourceOptions" :clearable="false"
                                    @input="filter" :reduce="option => option.value">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 250px">
                            <div class="w-full">
                                <label class="vs-input--label">Chi nhánh</label>
                                <v-select v-model="selectedBranch" :options="branchOptions" name="branch"
                                    :clearable="false" @input="filter" :reduce="option => option.value">
                                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                                </v-select>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px">
                            <div class="w-full">
                                <label class="vs-input--label">Nhóm dịch vụ</label>
                                <vs-input v-model="beautyServicePackageName" @keyup.enter="filter"></vs-input>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px">
                            <div class="w-full">
                                <label>Nhân viên giới thiệu</label>
                                <vs-input class="w-full" v-model="referenceEmployee" @keyup.enter="filter"></vs-input>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px">
                            <div class="w-full">
                                <label>Nhân viên đặt lịch</label>
                                <vs-input></vs-input>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 250px">
                            <div class="w-full">
                                <label>Ngày đặt hẹn</label>
                                <div class="flex relative" style="width: 200px">
                                    <flat-pickr :config="configDatePicker" v-model="dateRange.startDate" @input="filter"
                                        class="vs-inputx vs-input--input normal" />
                                    <flat-pickr :config="configDatePicker" v-model="dateRange.endDate" @input="filter"
                                        class="vs-inputx vs-input--input normal" />
                                </div>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 250px">
                            <div class="w-full">
                                <label>Ngày đến hẹn</label>
                                <div class="flex relative" style="width: 200px">
                                    <flat-pickr :config="configDatePicker" v-model="dateRange.createdDate"
                                        @input="filter" class="vs-inputx vs-input--input normal" />
                                    <flat-pickr :config="configDatePicker" v-model="dateRange.toCreatedDate"
                                        @input="filter" class="vs-inputx vs-input--input normal" />
                                </div>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 200px">
                            <div class="w-full">
                                <label class="vs-input--label">Trạng thái</label>
                                <v-select :options="statusOptions" v-model="status" :clearable="false" @input="filter"
                                    :reduce="option => option.value">
                                </v-select>
                            </div>
                        </vs-th>
                        <vs-th style="min-width: 170px">
                            <div class="w-full">
                                <label class="vs-input--label">Hành động</label>
                            </div>
                        </vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                {{ tr.stt }}
                            </vs-td>

                            <vs-td class="text-primary">
                                {{ tr.customerName }}
                            </vs-td>
                            <vs-td class="text-primary">
                                <div class="flex gap-2">
                                    <span>{{ tr.phoneNumberCvt }}</span>
                                    <vx-tooltip class="position-icon" text="Gọi" position="top">
                                        <feather-icon icon="PhoneCallIcon" class="text-primary" svgClasses="h-5 w-5"
                                            @click="callCustomer(tr)" />
                                    </vx-tooltip>
                                </div>
                            </vs-td>
                            <vs-td class="text-primary">
                                {{ sourcePlatform(tr.loyaltyCustomer.sourcePlatform) }}
                                <p v-if="ratioSourceType[indextr]">
                                    <span style="color: blue;">{{ ratioSourceType[indextr].split(' ')[0] }}</span>
                                    <span style="color: red;margin-left: 4px;">{{ ratioSourceType[indextr].split(' ')[2]
                                        }}</span>
                                </p>
                                <feather-icon v-else icon="RotateCwIcon" class="action-success icon-btn animate-spin"
                                    svgClasses="h-5 w-5 hover:text-primary cursor-pointer" />
                            </vs-td>
                            <vs-td class="text-primary">
                                {{ checkSoure(tr.loyaltyCustomer.source) }}
                                <p v-if="ratioSource[indextr]">
                                    <span style="color: blue;">{{ ratioSource[indextr].split(' ')[0] }}</span>
                                    <span style="color: red;margin-left: 4px;">{{ ratioSource[indextr].split(' ')[2]
                                        }}</span>
                                </p>
                                <feather-icon v-else icon="RotateCwIcon" class="action-success icon-btn animate-spin"
                                    svgClasses="h-5 w-5 hover:text-primary cursor-pointer" />
                            </vs-td>
                            <vs-td class="text-primary">
                                {{ tr.organizationBranchName }}
                                <p v-if="ratioMXH[indextr]">
                                    <span style="color: blue;">{{ ratioMXH[indextr].split(' ')[0] }}</span>
                                    <span style="color: red;margin-left: 4px;">{{ ratioMXH[indextr].split(' ')[2]
                                        }}</span>
                                </p>
                                <feather-icon v-else icon="RotateCwIcon" class="action-success icon-btn animate-spin"
                                    svgClasses="h-5 w-5 hover:text-primary cursor-pointer" />
                            </vs-td>
                            <vs-td class="text-primary">
                                {{ tr.serviceBooking }}
                            </vs-td>
                            <vs-td class="text-primary">
                                {{ tr.loyaltyCustomer.referenceEmployee }}
                            </vs-td>
                            <vs-td>
                            </vs-td>
                            <vs-td>
                                {{ tr.dateCreated }}
                            </vs-td>
                            <vs-td>
                                {{ tr.dateBooking }}
                            </vs-td>
                            <vs-td>
                                <vs-chip class="ag-grid-cell-chip-customer" :color="chipColor(tr.status)">
                                    {{ checkStatus(tr.status) }}

                                </vs-chip>
                            </vs-td>
                            <!-- <vs-td>
                            <CellRendererStatus :rowData="tr"></CellRendererStatus>
                        </vs-td> -->
                            <vs-td>
                                <CellRendererActions :rowData="tr"></CellRendererActions>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>

            <div class="vx-row">
                <div class="vx-col md:w-1/2">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                        <span class="vx-col mt-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        beautyBookingData.length - currentPage * paginationPageSize > 0 ? currentPage *
                                            paginationPageSize
                                            : beautyBookingData.length
                                    }} /
                                    {{ totalElements }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="changePageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                        <span style="margin-left: 20px; margin-top: 8px;">{{ ratio }}%</span>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
                </div>
            </div>
        </div>
        <vs-popup class="holamundo" title="Thông tin khách hàng" fullscreen :active.sync="popupAddCustomer"
            v-if="popupAddCustomer">
            <CustomerInformation :isProp="true" />
        </vs-popup>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import DateRangePicker from '../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import { AgGridVue } from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from "moment";
import Pagination from "../../../ui-elements/Pagination.vue";
import { isAPI } from "../../../../store/permission";
import { constAPI } from "../../../../store/constant";
import CellRendererStatus from "./cell-renderer/CellRendererStatusBooking.vue";
import CellRendererActions from "./cell-renderer/CellRendererActionsBooking.vue";
import CustomerInformation from "@/views/user-pages/crm-module/customer/CustomerInformation";
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components: {
        vSelect,
        DateRangePicker,
        AgGridVue,
        CellRendererStatus,
        CellRendererActions,
        Pagination,
        CustomerInformation,
        flatPickr

    },

    data() {
        return {
            branchOptions: [],
            selectedBranch: null,
            selectedBranchValue: null,
            departmentOptions: [
                { value: null, label: 'Tất cả' }
            ],
            selectedDepartmentValue: null,
            doctorOptions: [
                { value: null, label: 'Tất cả' }
            ],
            selectedDoctorValue: null,
            customerOptions: [
                { value: null, label: 'Tất cả' }
            ],
            selectedCustomerValue: null,
            statusOptions: [
                { value: null, label: 'Tất cả' },
                { value: 1, label: 'Xử lí' },
                { value: 2, label: 'Xác nhận' },
                { value: 3, label: 'Hoàn thành' },
                { value: 4, label: 'Hủy' },
            ],
            sourcePlatformOptions: [
                { value: null, label: 'Tất cả' },
                { value: 1, label: 'Facebook' },
                { value: 2, label: 'Zalo' },
                { value: 3, label: 'Website' },
                { value: 4, label: 'Tiktok' },
            ],
            sourceOptions: [
                { value: null, label: 'Tất cả' },
                { value: 1, label: 'Phòng kinh doanh 1' },
                { value: 2, label: 'Phòng kinh doanh 2' },
                { value: 3, label: 'Nhân viên' },
                { value: 4, label: 'Phòng kinh doanh 3' },
                { value: 5, label: 'Phòng kinh doanh 4' },
                { value: 6, label: 'Nguồn khác' },
                { value: 7, label: 'Nguồn App' },
            ],
            dateRange: {
                startDate: null,
                endDate: null,
                createdDate: null,
                toCreatedDate: null
            },
            configDatePicker: {
                dateFormat: 'Z',
                locale: Vietnamese,
                altFormat: 'd/m/Y',
                altInput: true,
                allowInput: true,
            },
            beautyBookingData: [],
            gridApi: null,
            pageNumber: 0,
            pageSize: 50,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            observer: null,
            limit: 20,
            search: '',
            typingSearchCustomer: null,
            textTypingSearch: null,
            pageNumberCustomer: 0,
            pageSizeCustomer: 50,
            showListCustomer: false,
            popupAddCustomer: false,
            customerName: null,
            dataConfig: [],
            sourcePlatformValue: null,
            sourceValue: null,
            phoneNumber: null,
            referenceEmployee: null,
            beautyServicePackageName: null,
            status: null,
            ratio: null,
            ratioSourceType: [],
            ratioSource: [],
            ratioMXH: [],
        }
    },

    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 50
        },

        filtered() {
            return this.customerOptions;
        },
        paginated() {
            return this.filtered.slice(0, this.limit);
        },
        hasNextPage() {
            return true;
        },
        sourcePlatform() {
            return value => {
                if (value === 1) {
                    return 'Facebook'
                }
                else if (value === 2)
                    return 'Zalo OA'
                else if (value === 3)
                    return 'Website'
                else if (value === 4)
                    return 'Tiktok'
                else {
                    return ''
                }
            }
        },
        checkSoure() {
            return value => {
                if (value === 1) {
                    return 'Phòng kinh doanh 1'
                }
                else if (value === 2)
                    return 'Phòng kinh doanh 2'
                else if (value === 3)
                    return 'Nhân viên'
                else if (value === 4)
                    return 'Phòng kinh doanh 3'
                else if (value === 5)
                    return 'Phòng kinh doanh 4'
                else if (value === 6)
                    return 'Nguồn khác'
                else if (value === 7)
                    return 'Nguồn App'
                else {
                    return ''
                }
            }
        },
        chipColor() {
            return value => {
                if (value == 1) {
                    return "warning"
                } else if (value == 2) {
                    return "primary"
                } else if (value == 3) {
                    return "success"
                } else if (value == 4) {
                    return "danger"
                }
            }
        },
        checkStatus() {
            return value => {
                if (value === 1) {
                    return 'Chờ xử lý'
                } else if (value === 2) {
                    return 'Đã xác nhận'
                } else if (value === 3) {
                    return 'Đã hoàn thành'
                } else if (value === 4) {
                    return 'Hủy'
                }
            }
        }
    },

    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return { label: x.organizationBranchName, value: x.id }
        });
        this.branchOptions.unshift({ value: null, label: 'Tất cả' });

        if (this.$route.query.customerId) {
            this.selectedCustomerValue = parseInt(this.$route.query.customerId, 10)
        }
        await this.searchBooking();
        await this.getDepartmentData();
        await this.getDepartmentConfig();
        await this.getAllRadio();
        await this.getCustomerData();


    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteBeautyBooking'(val) {
            if (val) {
                this.searchBooking();
                this.$store.commit('DELETE_BEAUTY_BOOKING', false);
            }
        }
    },

    methods: {

        convertPhone(phone) {
            let arrPhone = phone.split('');
            arrPhone[4] = '*';
            arrPhone[5] = '*';
            arrPhone[6] = '*';
            return arrPhone.join().replaceAll(',', '');
        },

        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },

        getDepartmentData() {
            return new Promise((resolve, reject) => {
                let body = {
                    organizationBranchId: this.selectedBranchValue,
                }

                this.departmentOptions = [];

                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', body).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.departmentOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.departmentName
                            }
                        });
                    }
                    this.departmentOptions.unshift({ value: null, label: 'Tất cả' });
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getAllRadio() {
            const body = {
                departmentId: this.selectedDepartmentValue,
                organizationBranchId: this.selectedBranch,
                performerId: this.selectedDoctorValue,
                createdDate: this.dateRange.startDate,
                startDate: this.dateRange.createdDate,
                endDate: this.dateRange.toCreatedDate,
                toCreatedDate: this.dateRange.endDate,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                customerName: this.customerName,
                sourcePlatform: this.sourcePlatformValue,
                source: this.sourceValue,
                phoneNumber: this.phoneNumber,
                referenceEmployee: this.referenceEmployee,
                beautyServicePackageName: this.beautyServicePackageName,
                status: this.status
            }
            this.$vs.loading();
            this.$crm.post(`loyalty/potential-customer/radio_booking`, body).then(response => {
                this.ratioSourceType = []
                this.ratioMXH = []
                this.ratioSource = []
                if (response.data.list.length > 1) {
                    response.data.list.forEach(el => {
                        this.ratioSourceType.push(el.radioSourceType);
                        this.ratioMXH.push(el.radioOrganizationBranchId);
                        this.ratioSource.push(el.radioDepartmentId);
                    });
                }
                this.ratio = response.data.radioBooking

            })
        },

        getDepartmentConfig() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();

                this.$crm.get('/setting/organization-pancake-config/find-config-by-organization-id').then(res => {
                    this.$vs.loading.close();
                    this.dataConfig = res.data.map(el => {
                        return {
                            value: el.departmentId,
                            label: this.departmentOptions.find(x => x.value === el.departmentId).label,
                            organizationBranchName: this.departmentOptions.find(x => x.value === el.departmentId).organizationBranchName,
                        }
                    });
                    this.dataConfig.unshift({ label: 'Tất cả', value: 'null' })
                    resolve(res);
                }).catch(err => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },



        getCustomerData() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let url = '/loyalty/customer/find'
                if (this.textTypingSearch != this.search) {
                    this.textTypingSearch = this.search;
                    this.customerOptions = [
                        { value: null, label: 'Tất cả' }
                    ];
                }
                url += `?pageNumber=${this.pageNumberCustomer}&pageSize=${this.pageSizeCustomer}`;
                if (this.textTypingSearch) url += `&keySearch=${this.textTypingSearch}`;
                this.$crm.get(url).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        let customer = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.phoneNumber + ' - ' + el.fullName
                            }
                        });
                        this.customerOptions.push(...customer);
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setUTCHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setUTCHours(16, 59, 59, 999));
        },

        searchBooking() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let payload = {
                departmentId: this.selectedDepartmentValue,
                organizationBranchId: this.selectedBranch ? this.selectedBranch : userInfo.organizationBranchId,
                performerId: this.selectedDoctorValue,
                createdDate: this.dateRange.startDate,
                startDate: this.dateRange.createdDate,
                endDate: this.dateRange.toCreatedDate,
                toCreatedDate: this.dateRange.endDate,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                customerName: this.customerName,
                sourcePlatform: this.sourcePlatformValue,
                source: this.sourceValue,
                phoneNumber: this.phoneNumber,
                referenceEmployee: this.referenceEmployee,
                beautyServicePackageName: this.beautyServicePackageName,
                status: this.status
            }

            this.$vs.loading();
            this.$crm.post('/beauty-booking/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.beautyBookingData = res.data.content.map(el => {
                        el.stt = this.pageSize * this.pageNumber + res.data.content.indexOf(el) + 1;
                        let branch = this.branchOptions.find(x => x.value == el.organizationBranchId);
                        el.organizationBranchName = branch ? branch.label : null;
                        el.doctorName = el.beautyBookingDetails[0].performer ? el.beautyBookingDetails[0].performer.fullName : null;
                        el.phoneNumberCvt = el.loyaltyCustomer.phoneNumber ? this.convertPhone(el.loyaltyCustomer.phoneNumber) : null;
                        el.dateBooking = moment(el.beautyBookingDetails[0].bookingTime).format('DD/MM/YYYY HH:mm');
                        el.dateCreated = moment(el.beautyBookingDetails[0].createdDate).format('DD/MM/YYYY HH:mm')
                        el.serviceBooking = el.beautyBookingDetails[0].beautyServicePackage ? el.beautyBookingDetails[0].beautyServicePackage.name : el.beautyBookingDetails[0].beautyPackageCombo ? el.beautyBookingDetails[0].beautyPackageCombo.name : null;
                        el.customerName = el.loyaltyCustomer.phoneNumber + ' - ' + el.loyaltyCustomer.fullName;
                        return el;
                    })
                } else {
                    this.beautyBookingData = [];
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        onGridReady(params) {
            this.gridApi = params.api;
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllRadio();
                this.searchBooking();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.searchBooking();
        },

        isPermissionCreateBooking() {
            return isAPI(this, constAPI.beauty_booking_create);
        },

        isPermissionUpdateBooking() {
            return isAPI(this, constAPI.beauty_booking_update);
        },

        isPermissionDeleteBooking() {
            return isAPI(this, constAPI.beauty_booking_delete);
        },
        callCustomer(data) {
            this.$eventBus.$emit("beauty-call", data);
        },

        async onOpen() {
            this.showListCustomer = true;
            if (this.hasNextPage) {
                await this.$nextTick()
                this.observer.observe(this.$refs.load)
            }
        },
        onClose() {
            this.search = '';
            this.pageNumberCustomer = -1;
            this.showListCustomer = false;
            this.observer.disconnect()
        },
        async infiniteScroll([{ isIntersecting, target }]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 20;
                this.pageNumberCustomer += 1;
                await this.$nextTick();
                ul.scrollTop = scrollTop;
                this.getCustomerData();
            }
        },

        searchCustomer(query) {
            if (this.showListCustomer) {
                if (this.search != query) this.pageNumberCustomer = 0;
                this.search = query;
                clearTimeout(this.typingSearchCustomer);
                this.typingSearchCustomer = setTimeout(this.doneTypingSearch, 1500)
            }
        },

        async doneTypingSearch() {
            await this.getCustomerData(true);
            if (this.customerOptions.length === 1) this.selectedCustomerValue = null;
            await this.onOpen();
        },

        filter() {
            // this.pageNumber = 0;
            // this.currentPage = 1;
            this.getAllRadio()
            this.searchBooking();
        }
    },

    mounted() {
        this.observer = new IntersectionObserver(this.infiniteScroll);
        this.$eventBus.$on("popup-add-customer", (event) => {
            if (event) this.popupAddCustomer = false;
        })
    },
}
</script>

<style lang="scss">
.vs--single .vs__selected {
    /* max-width: 160px !important; */
    /* min-width: 150px !important; */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.customer-manage {
    .vs-con-table {
        overflow-y: scroll;
        //height: 600px !important;

        .vs-table--content {
            overflow: visible !important;

            .vs-con-tbody {
                overflow: visible !important;
                //overflow-x: scroll !important;
            }

            .vs-table--thead th {
                position: sticky;
                top: 0;
                background: #FFFFFF;
                z-index: 999;
            }

            tr:nth-child(even) {
                background-color: #f8f8f8;
            }
        }
    }



    .ag-grid-cell-chip-customer {
        &.vs-chip-primary {
            background: rgba(var(--vs-primary), .2);
            color: rgba(var(--vs-primary), 1) !important;
            font-weight: 500;
        }

        &.vs-chip-success {
            background: rgba(var(--vs-success), .2);
            color: rgba(var(--vs-success), 1) !important;
            font-weight: 500;
        }

        &.vs-chip-warning {
            background: rgba(var(--vs-warning), .2);
            color: rgba(var(--vs-warning), 1) !important;
            font-weight: 500;
        }

        &.vs-chip-danger {
            background: rgba(var(--vs-danger), .2);
            color: rgba(var(--vs-danger), 1) !important;
            font-weight: 500;
        }
    }
}
</style>
